// SuccessCard.jsx
import React from "react";
import "./Card.css"; // Import the external CSS
import ReactDOM from "react-dom";
const Card = ({ onClose, status }) => {
  return ReactDOM.createPortal(
    <div className="modal-overlay">
      <div className="modal">
        <h2>Photos {status} Successfully!</h2>
        <div className="modal-buttons">
          <button className="modal-confirm" onClick={onClose}>
            ok
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Card;
